var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full py-4"},[_vm._v(" Marketing ")])}
var staticRenderFns = []

export { render, staticRenderFns }